import { render, staticRenderFns } from "./PrivacyUsePage.vue?vue&type=template&id=7ed3f569"
import script from "./PrivacyUsePage.vue?vue&type=script&lang=js"
export * from "./PrivacyUsePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports